import React from 'react';
import { UTLabel } from '@widergy/energy-ui';

import plugPng from '../../../../assets/ic_plug@2x.png';
import savingPng from '../../../../assets/ic_saving@2x.png';
import co2Png from '../../../../assets/ic_co2@2x.png';

import styles from './styles';

const images = { plugPng, savingPng, co2Png };
const variants = ['plug', 'saving', 'co2'];

export default function LabeledIcon({ children, ...props }) {
  const image = variants.filter(variant => props[variant]).map(variant => images[`${variant}Png`]);

  return (
    <div style={styles.container}>
      <img height={45} src={image} alt="" />
      <UTLabel small style={styles.titleProgress}>
        {children}
      </UTLabel>
    </div>
  );
}
